import { useChatStore } from '@/store/chatStore';
import ChatMessageList from './MessageList';
import ChatMessageInput from './MessageInput';

export default function ChatWindow() {
  const {
    sessions,
    currentSessionId,
    isLoading,
    sendMessage,
    createSession,
  } = useChatStore();

  const handleSendMessage = async (message: string) => {
    let sessionId = currentSessionId;
    
    if (!sessionId) {
      // Create a new session if none exists
      sessionId = `session-${Date.now()}`;
      createSession(sessionId);
    }

    await sendMessage(sessionId, message);
  };

  const currentSession = currentSessionId ? sessions[currentSessionId] : null;
  const messages = currentSession?.messages || [];

  return (
    <div className="chat-window">
      <div className="chat-header">
        <h2>Agent Chat</h2>
        {currentSessionId && (
          <span className="session-id">Session: {currentSessionId}</span>
        )}
      </div>
      
      <ChatMessageList messages={messages} />
      
      {isLoading && (
        <div className="loading-indicator">
          <span>Agent is thinking...</span>
        </div>
      )}
      
      <ChatMessageInput onSend={handleSendMessage} isLoading={isLoading} />
    </div>
  );
}
